export function calculateInvoice(data) {
  console.log('invoice')
  console.log(data)
  
  const IMPRESSIONS_PER_FOLLOWER = 144;
  const RPM = 19.80;

  const FOUR_YEARS = 1460;
  const STV = 0.34;


  const POST_BOOST = 1.626;
  const CLV = 0.50;


  const contentRevenue = (data.followerCount * IMPRESSIONS_PER_FOLLOWER / 1000) * RPM;
  const scrollTimeValue = (data.activeMins / 60) * FOUR_YEARS * STV;
  const creativeLabourValue = (data.postCount * POST_BOOST) * data.minsPerPost * (data.valueType / 60);
  const wellbeingDamages = 6000;

  const total = contentRevenue + scrollTimeValue + creativeLabourValue + wellbeingDamages;

  return {
    contentRevenue: contentRevenue.toFixed(2),
    scrollTimeValue: scrollTimeValue.toFixed(2),
    creativeLabourValue: creativeLabourValue.toFixed(2),
    wellbeingDamages: wellbeingDamages.toFixed(2),

    total: total.toFixed(2)

  };
}
